import { Theme } from "@chakra-ui/react";

export const breakpoints: Partial<Theme["breakpoints"]> = {
    sm: "30em",
    md: "48em",
    lg: "62em",
    xl: "79em",
    "2xl": "96em",
};
